import React from 'react';
import { Helmet } from 'react-helmet';
export const SEO = () => {
  const title = 'Aurum Grove Capital | Strategic Investment Management';
  const description = 'Aurum Grove Capital manages investments for a select group of family and friends in the Indian market, with a long-term approach focused on sustainable growth and wealth preservation.';
  const siteUrl = 'https://aurumgrove.capital'; // Replace with actual URL when deployed
  const ogImage = 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.1&auto=format&fit=crop&w=1200&h=630&q=80'; // Replace with actual image URL
  // JSON-LD structured data for investment company
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FinancialService',
    name: 'Aurum Grove Capital',
    description: description,
    url: siteUrl,
    logo: ogImage,
    sameAs: [],
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'IN'
    },
    openingHours: 'Mo,Tu,We,Th,Fr 09:00-17:00',
    serviceType: ['Investment Management', 'Long-term Growth Strategies', 'Balanced Portfolios', 'Alternative Investments']
  };
  return <Helmet data-id="element-169" data-mp="1zkb8gsehihrt">
      {/* Keep existing title and meta description */}
      <title data-id="element-170" data-mp="1zigp3iiv2xpu">{title}</title>
      <meta name="description" content={description} data-id="element-171" data-mp="1ul8dy1w4rty3" />
      {/* Meta robots tag for crawler visibility */}
      <meta name="robots" content="index, follow" data-id="element-172" data-mp="1qjd4ga41qa98" />
      {/* Open Graph tags */}
      <meta property="og:type" content="website" data-id="element-173" data-mp="1qlg5rqanfpt9" />
      <meta property="og:url" content={siteUrl} data-id="element-174" data-mp="1lrvba889ldyt" />
      <meta property="og:title" content={title} data-id="element-175" data-mp="1gttj8xsv24b7" />
      <meta property="og:description" content={description} data-id="element-176" data-mp="1gulged23wa3l" />
      <meta property="og:image" content={ogImage} data-id="element-177" data-mp="1buz4c6y0kzwd" />
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-178" data-mp="1bsw5cxevvwfi" />
      <meta name="twitter:title" content={title} data-id="element-179" data-mp="16v4dg3e8oabb" />
      <meta name="twitter:description" content={description} data-id="element-180" data-mp="12uaqbc8mezjh" />
      <meta name="twitter:image" content={ogImage} data-id="element-181" data-mp="12w5agoc2inmi" />
      {/* Structured data */}
      <script type="application/ld+json" data-id="element-182" data-mp="s7drl0xito7w">
        {JSON.stringify(structuredData)}
      </script>
      {/* Canonical URL */}
      <link rel="canonical" href={siteUrl} data-id="element-183" data-mp="x5nmdafc2msz" />
    </Helmet>;
};